import React, {Component, useContext} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {
    Bar,
    BarChart,
    CartesianGrid, Legend,
    ResponsiveContainer, Tooltip,
    XAxis,
    YAxis
} from "recharts";
import Paper from "@material-ui/core/Paper";
import AppContext from '../../AppContext'
import {scaleOrdinal, schemeBlues} from "d3"
import {Card} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import CardContent from "@material-ui/core/CardContent";

// http://colorbrewer2.org/?type=sequential&scheme=GnBu&n=6

const RestraintsPanel = props => {
    const {dataContributions} = props;
    const hueSize = dataContributions ? Object.keys(dataContributions[0]).length - 1 : 0;
    const d3Palette = hueSize < 4 ? ['#deebf7','#9ecae1','#3182bd'] : schemeBlues[hueSize];
    return (
        <Card>
            <CardContent>
                <Typography
                    variant="h3"
                    align="center"
                    gutterBottom>
                    Contribution
                    histogram
                </Typography>
                <ResponsiveContainer
                    width="100%"
                    height={600}>
                    <BarChart
                        data={dataContributions}
                        margin={{
                            top: 5,
                            right: 20,
                            bottom: 20,
                            left: 20
                        }}
                    >
                        <CartesianGrid
                            strokeDasharray="3 3"/>
                        <XAxis
                            dataKey="name"
                            fontFamily="sans-serif"
                            label={{
                                value: "Number of contributions",
                                offset: -5,
                                position: "insideBottom"
                            }}
                        />
                        <YAxis
                            fontFamily="sans-serif"
                            label={{
                                value: "Number of restraints",
                                offset: 0,
                                angle: -90,
                                position: "insideLeft"
                            }}
                        />
                        <Tooltip/>
                        <Legend
                            verticalAlign="top"/>
                        {
                            Object.keys(dataContributions[0]).filter(dataKey => dataKey !== "name").map(
                                (dataEntry, index) => {
                                    return <Bar
                                        key={index}
                                        dataKey={dataEntry}
                                        fill={d3Palette[index]}
                                        fontFamily="sans-serif"
                                    />
                                }
                            )
                        }
                        }
                    </BarChart>
                </ResponsiveContainer>
            </CardContent>
        </Card>
    );
};


export default RestraintsPanel;